import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Container from 'common/Container';
import { Hero, Packages, WhySystem, FinalCta, WhatsAppFloat } from './components';
import { PAGE_TITLE, PAGE_DESCRIPTION, CHERRY_DEV } from './annaSanelliaContent';
import { CHERRY_SOFTWARE_CONTAINER_PROPS } from '../CherrySoftware/cherrySoftwareLayout';
import { CherryDevTheme } from '../CherrySoftware/CherryDevTheme';

const LandingAnnaSanelliaInner = () => {
  useEffect(() => {
    document.title = PAGE_TITLE;
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute('content', PAGE_DESCRIPTION);
  }, []);

  return (
    <Box
      sx={{
        bgcolor: CHERRY_DEV.cream,
        fontFamily: '"Outfit", "Segoe UI", system-ui, sans-serif',
      }}
    >
      <Hero />

      <Container {...CHERRY_SOFTWARE_CONTAINER_PROPS}>
        <Packages />
      </Container>

      <Box bgcolor={CHERRY_DEV.blush}>
        <Container {...CHERRY_SOFTWARE_CONTAINER_PROPS}>
          <WhySystem />
        </Container>
      </Box>

      <Container {...CHERRY_SOFTWARE_CONTAINER_PROPS}>
        <FinalCta />
      </Container>

      <WhatsAppFloat />
    </Box>
  );
};

const LandingAnnaSanellia = () => (
  <CherryDevTheme>
    <LandingAnnaSanelliaInner />
  </CherryDevTheme>
);

LandingAnnaSanellia.propTypes = {
  themeMode: PropTypes.string,
};

export default LandingAnnaSanellia;
